"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../Button"));
var _StyledTable = require("../styled/StyledTable");
var _excluded = ["children", "className", "disabled", "viewMode"];
var EditableCellButton = function EditableCellButton(_ref) {
  var _tooltipChildren, _tooltipChildren$prop;
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    viewMode = _ref.viewMode,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var tooltipChildren = children[1];
  if ((0, _typeof2.default)(tooltipChildren) === 'object') tooltipChildren = (_tooltipChildren = tooltipChildren) === null || _tooltipChildren === void 0 ? void 0 : (_tooltipChildren$prop = _tooltipChildren.props) === null || _tooltipChildren$prop === void 0 ? void 0 : _tooltipChildren$prop.children;
  if (viewMode) {
    return /*#__PURE__*/_react.default.createElement(_StyledTable.StyledViewModeButton, {
      title: tooltipChildren
    }, children);
  }
  return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    className: 'editable-cell-button ' + (className || ''),
    tabIndex: "0",
    type: "ghost",
    title: tooltipChildren,
    disabled: disabled
  }, restProps), children);
};
var _default = exports.default = EditableCellButton;